import { render, staticRenderFns } from "./FormApprove.vue?vue&type=template&id=fe210970"
import script from "./FormApprove.vue?vue&type=script&lang=js"
export * from "./FormApprove.vue?vue&type=script&lang=js"
import style0 from "./FormApprove.vue?vue&type=style&index=0&id=fe210970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports